"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var FinalMessage_module_scss_1 = __importDefault(require("./FinalMessage.module.scss"));
function FinalMessage() {
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: FinalMessage_module_scss_1.default.container_final_message }, { children: [(0, jsx_runtime_1.jsx)("video", { autoPlay: true, loop: true, muted: true, playsInline: true, src: "https://loop-markets.directus.app/assets/90393d46-7bc7-4394-9d70-91a83e5d6da9" }), (0, jsx_runtime_1.jsx)("h1", __assign({ style: { marginBottom: "10px" } }, { children: "Powered by Blockchain Technology" })), (0, jsx_runtime_1.jsxs)("p", __assign({ style: { marginBottom: "10px" } }, { children: ["Giving Artist and Creators the tools they need to create", (0, jsx_runtime_1.jsx)("br", {}), " fan-base communities"] }))] })));
}
exports.default = FinalMessage;
